var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal-backdrop show"}),_c('div',{staticClass:"modal d-block",attrs:{"tabindex":"-1","role":"dialog"}},[_c('div',{class:( _obj = {
      'modal-dialog modal-dialog-centered': true
    }, _obj[_vm.type] = true, _obj ),attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content bs"},[_c('div',{staticClass:"modal-body"},[_vm._t("default")],2)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }